module.exports = __webpack_public_path__ + "img/hall_of_fame.svg";